interface AppLayoutProps {
  children: React.ReactNode;
}

/**
 * Layout wrapper for /app/* routes
 * Note: Loading state is handled by AppProvider
 */
export function AppLayout({ children }: AppLayoutProps) {
  return <>{children}</>;
}
